// Library Class
import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
import { BlanketOrderSummaryVM } from '../../../models/BO/BlanketOrderSummaryVM';
// Models
import { CPPLandingFilterVM } from '../../../models/CPP/CPPLandingFilterVM';
import { MobilePDFVM } from '../../../models/CPP/MobilePDFVM';
// Service Class
import { BlanketOrderService } from '../../../services/blanket-order/blanket-order.service';
import { CommonService } from '../../../services/common/common.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
// Class
import { MasterConstants } from './../../../common/constants/master-constants';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-blanket-order-grid',
  templateUrl: './blanket-order-grid.component.html',
  styleUrls: ['./blanket-order-grid.component.scss']
})
export class BlanketOrderGridComponent implements OnInit, OnChanges, OnDestroy {
  private subscription = new Array<Subscription>();

  @Input() filter: CPPLandingFilterVM = new CPPLandingFilterVM();
  @Output() Search: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('blanketOrderCPPOrdersTable', { read: MatSort }) blanketOrderCPPOrdersTable: MatSort;
  @ViewChild('blanketCPPOrdersPaginator', { read: MatPaginator }) blanketCPPOrdersPaginator: MatPaginator;
  public blanketCPPOrdersDataSource: MatTableDataSource<any>;
  blanketOrderCPPOrdersColumns: string[];
  blanketOrderCPPOrdersList: any = [];

  // PDF functionality variables.
  masterConstants = MasterConstants;
  pdfDataObject: any;
  orderPdf: BlanketOrderSummaryVM = new BlanketOrderSummaryVM();
  totalNumbersOfOrder = 0;
  totalnumbersOfProduct = 0;
  isBulkItemAvailable: boolean = false;
  isPackagedItemAvailable: boolean = false;
  totalOrderCost = 0;
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  IsMobile = false;
  basePdfData: string;
  filter2: MobilePDFVM = new MobilePDFVM();
  deliverToAccountdetails: any = {};
  soldToAccountdetails: any = {};
  // end pdf functionality variables.
  plAccess = false;
  headerCompany = MasterConstants.US_COMPANYCODE;
  tabNode = false;
  disclaimerMessage: string;
  isSubscriptionAccess = true;
  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private blanketOrderService: BlanketOrderService,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        // Set Subscription Access
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
        } else {
          this.isSubscriptionAccess = true;
        }

        this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
      }
    }
    this.setGridDisplayedColumns();
  }

  setGridDisplayedColumns() {
    if (this.filter.gridType == 'PLACED') {
      this.blanketOrderCPPOrdersColumns = ['blanketOrderNumber', 'accountName', 'accountNumber', 'blanketOrderDate', 'blanketOrderCloseDate', 'blanketOrderStatus', 'customerPONumber', 'openLines', 'contextMenu'];
    } else if (this.filter.gridType == 'DRAFT') {
      this.blanketOrderCPPOrdersColumns = ['blanketOrderNumber', 'accountName', 'accountNumber', 'blanketOrderDate', 'blanketOrderStatus', 'customerPONumber', 'Lines', 'contextMenuDraft'];
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const filterChanges = changes.filter;

    if (filterChanges && JSON.stringify(filterChanges.currentValue) !== JSON.stringify(filterChanges.previousValue)) {
      this.setGridDisplayedColumns();
      this.getBlanketOrders();
    }
  }

  getBlanketOrders() {
    this.loaderService.setLoaderStatus(true);
    this.blanketCPPOrdersDataSource = new MatTableDataSource([]);

    this.subscription.push(this.blanketOrderService.blanetOrderItemsList(this.filter).subscribe((result: any[]) => {
      this.blanketOrderCPPOrdersList = result;
      this.Search.emit(this.blanketOrderCPPOrdersList);
      this.blanketCPPOrdersDataSource = new MatTableDataSource(result);
      this.blanketCPPOrdersDataSource.paginator = this.blanketCPPOrdersPaginator;
      this.blanketCPPOrdersDataSource.paginator.firstPage();
      this.blanketCPPOrdersDataSource.sort = this.blanketOrderCPPOrdersTable;
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  viewBlanketOrder(blanketElement) {
    this.blanketOrderService.webOrderNumber = blanketElement.blanketOrderNumber + '~' + 'EABlanket' + '~CPPLanding';
    if (this.filter.gridType == 'PLACED') { this.router.navigate(['/cpp/blanket-order-summary']); }
    else { this.router.navigate(['/cpp/blanket-order-create']); }
  }

  deleteOrder(blanketElement) {
    if (blanketElement) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: { title: 'Delete Order', message: 'Do you want to delete this saved order?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });

      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);

          this.subscription.push(this.blanketOrderService.deleteBlanketOrder(blanketElement.blanketOrderNumber).subscribe((result: any) => {
            if (result) { this.getBlanketOrders(); }
            this.loaderService.setLoaderStatus(false);
          }, error => {
            this.loaderService.setLoaderStatus(false);
          }));
        }
      }));
    }
  }

  generateBlanketPdf(blanketOrder: any, isAll: boolean = true) {
    // console.log('generateBlanketPdf');
    // console.log(blanketOrder);
    if (blanketOrder.blanketOrderNumber) {
      this.loaderService.setLoaderStatus(true);
      const self = this;

      this.subscription.push(this.blanketOrderService.getOrderSummaryDetails(blanketOrder.blanketOrderNumber).subscribe((result: BlanketOrderSummaryVM) => {
        if (result) {
          // console.log(result);
          if (result !== undefined && result.splitDetails.length > 0) {
            self.orderPdf = result;
            this.pdfDataObject = result;
            this.totalNumbersOfOrder = result.splitDetails.length;
            result.splitDetails.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
            const documentDefinition = this.getDocumentDefinition();
            if (this.isMobile) {
              const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
              pdfDocGenerator.getBase64((data) => {
                this.basePdfData = data;
                const currentDateTime = new Date();
                this.filter2 = {
                  MobilePDFBase64: this.basePdfData,
                  FileName: 'EarlyAdvantageOrder_' + blanketOrder.blanketOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf'
                };

                this.subscription.push(this.blanketOrderService.sendBaseDate(this.filter2).subscribe((result) => {
                  window.location.assign(result.filePath);
                  this.loaderService.setLoaderStatus(false);
                }, error => this.loaderService.setLoaderStatus(false)));
              });
            }
            else {
              pdfMake.createPdf(documentDefinition).download('EarlyAdvantageOrder_' + blanketOrder.blanketOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
            }
          } else {
            this.toastrService.error('No data available for WebOrderNumber #' + blanketOrder.blanketOrderNumber);
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      }));
    }
  }

  // Get the details filled for variables above and below the table in PDF
  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MM/dd/yyyy');
    // const orderCreateDate = new Date(this.pdfDataObject.createdOn);
    const orderCreateDate = this.pdfDataObject.createdOnString;

    if (this.pdfDataObject.deliverToDetail) {
      this.deliverToAccountdetails.AccountNumber = this.pdfDataObject.deliverToDetail.accountNo;
      this.deliverToAccountdetails.AccountName = this.pdfDataObject.deliverToDetail.accountName;
      this.deliverToAccountdetails.Address1 = this.pdfDataObject.deliverToDetail.address1;
      this.deliverToAccountdetails.AccountCity = this.pdfDataObject.deliverToDetail.city;
      this.deliverToAccountdetails.AccountState = this.pdfDataObject.deliverToDetail.state;
      this.deliverToAccountdetails.AccountZipCode = this.pdfDataObject.deliverToDetail.zipCode;
    }

    // this.soldToAccountdetails
    if (this.pdfDataObject.soldToDetail) {
      this.soldToAccountdetails.AccountNumber = this.pdfDataObject.soldToDetail.accountNo;
      this.soldToAccountdetails.AccountName = this.pdfDataObject.soldToDetail.accountName;
      this.soldToAccountdetails.Address1 = this.pdfDataObject.soldToDetail.address1;
      this.soldToAccountdetails.Address2 = this.pdfDataObject.soldToDetail.address2.replace('<br>', '');
      this.soldToAccountdetails.AccountCity = this.pdfDataObject.soldToDetail.city;
      this.soldToAccountdetails.AccountState = this.pdfDataObject.soldToDetail.state;
      this.soldToAccountdetails.AccountZipCode = this.pdfDataObject.soldToDetail.zipCode;
    }

    let displayWith = [];
    let columnList = [];
    let valueList = [];
    let bulkdetailsheader;

    // ShipTo Account available
    if (!this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['100%'];
      columnList = [{ text: 'SHIP TO:', bold: true }];
      // columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo & DeliverTo  Account available
    else if (this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SHIP TO:', bold: true }, { text: 'DELIVER TO:', bold: true }];
      // columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',
      ];
    }
    // ShipTo & SoldTo Account available
    else if (!this.deliverToAccountdetails.AccountName && this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SOLD TO:', bold: true }, { text: 'SHIP TO:', bold: true }];
      // columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo, SoldTo & DeliverTo Account available
    else {
      displayWith = ['33%', '33%', '33%'];
      columnList = [{ text: 'SOLD TO:', bold: true }, { text: 'SHIP TO:', bold: true }, { text: 'DELIVER TO:', bold: true }];
      // columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',

      ];
    }
    if (this.isBulkItemAvailable && this.isPackagedItemAvailable) {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, "MM/dd/yyyy")],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          ['BULK CONTACT NAME:', this.pdfDataObject.bulkContactName],
          ['BULK CONTACT PHONE NUMBER:', this.pdfDataObject.bulkContactNumber],
          ['CONTACT NAME:', this.pdfDataObject.packagedContactName],
          ['CONTACT PHONE NUMBER:', this.pdfDataObject.packagedContactNumber],
          ['DELIVERY INSTRUCTIONS:', this.pdfDataObject.packagedDeliveryInst],
        ]
      };
    }
    else if (this.isBulkItemAvailable) {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, "MM/dd/yyyy")],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          ['BULK CONTACT NAME:', this.pdfDataObject.bulkContactName],
          ['BULK CONTACT PHONE NUMBER:', this.pdfDataObject.bulkContactNumber],
        ]
      };
    }
    else if (this.isPackagedItemAvailable) {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, "MM/dd/yyyy")],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          ['CONTACT NAME:', this.pdfDataObject.packagedContactName],
          ['CONTACT PHONE NUMBER:', this.pdfDataObject.packagedContactNumber],
          ['DELIVERY INSTRUCTIONS:', this.pdfDataObject.packagedDeliveryInst],
        ]
      };
    }
    else {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, "MM/dd/yyyy")],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          //['ACCOUNT NUMBER:', this.pdfDataObject.accountNumber],
        ]
      };
    }
    var pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: currDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          image: 'data:image/png;base64,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',
          width: 102,
          height: 37,
          alignment: 'left',
        },
        {
          layout: 'noBorders',
          table: bulkdetailsheader,
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            fontSize: 5,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'pageText',
          layout: 'noBorders',
        },
        {
          alignment: 'center',
          table: {
            body: [
              [this.disclaimerMessage],
            ]
          },
          layout: 'noBorders',
          fontSize: 8,
          color: '#6fc8c0',
          margin: [40, 5]
        },

        this.getContractPdfObject(this.pdfDataObject.splitDetails),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis order was committed by ' + this.pdfDataObject.placedByName + ' on ' + orderCreateDate
                + ' (CST). If you have any questions regarding these changes, please contact WinField United Customer Service, 1-855-494-6343. Shipments made at WinField® United\'s discretion.'],
            ]
          },
          layout: 'noBorders'
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#f5f4f2',
          fontSize: 8,
          color: '#0b3f54',
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
        tableUnit: {
          fontSize: 8,
          background: '#feeaa6',
          color: '#757575'
        },
        tablePayment: {
          fontSize: 8,
          background: '#b4e3df',
          color: '#757575'
        }
      }
    };

    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(splitDetails) {
    this.isBulkItemAvailable = false;
    this.isPackagedItemAvailable = false;
    var tblObject = [];
    var tbl = {};
    splitDetails.forEach(obj => {
      let jdeNumber = '';
      if (obj.jdeorderNumber) {
        jdeNumber = obj.jdeorderNumber;
      }
      if (obj.productDetail.some(x => x.bulkPackaged == 'bulk' || x.bulkPackaged == 'BULK')) {
        this.isBulkItemAvailable = true;
      }
      if (obj.productDetail.some(x => x.bulkPackaged == "packaged" || x.bulkPackaged == "PACKAGED")) {
        this.isPackagedItemAvailable = true;
      }
      var blanketOrderDetails = obj.productDetail;
      let desDelDate = (obj.productDetail[0].desiredDeliveryDate == null || obj.productDetail[0].desiredDeliveryDate == undefined) ? "" : obj.productDetail[0].desiredDeliveryDate;
      let desiredDeliveryDate = (desDelDate === "" ? "" : this.datePipe.transform(desDelDate.toString(), "MM/dd/yyyy"));
      if (jdeNumber != '' && this.isBulkItemAvailable) {
        var tblbulkHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '10%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Order ID: ' + this.pdfDataObject.webOrderNumber.toString() + '-' + obj.splitId.toString() + ' \n' + 'Status:' + obj.orderStatus.toString(),
              alignment: 'left',
              width: '35%'
            },
            {
              text: 'Status: ' + obj.orderStatus.toString(),
              alignment: 'left',
              width: '35%',
            },
            {
              text: 'Sales Order #: ' + jdeNumber,
              alignment: 'left',
              width: '30%',
            },
            ]
          }
        ];
        tblObject.push(tblbulkHeader);
      }
      else if (jdeNumber != '') {
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '10%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Order ID: ' + this.pdfDataObject.webOrderNumber.toString() + '-' + obj.splitId.toString(),
              alignment: 'left',
            },
            {
              text: 'Sales Order #: ' + jdeNumber,
              alignment: 'left',
            },
            {
              text: 'Status: ' + obj.orderStatus.toString(),
              alignment: 'left',
            }
              //  ,
              // {
              //  text: 'Requested Delivery Date: ' + desiredDeliveryDate,
              //  alignment: 'right',
              //  }
            ]
          }
        ];

        tblObject.push(tblHeader);
      }
      else if (this.isBulkItemAvailable) {
        var tblbulkItemHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '10%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Order ID: ' + this.pdfDataObject.webOrderNumber.toString() + "-" + obj.splitId.toString() + ' \n' + 'Status:' + obj.orderStatus.toString(),
              alignment: 'left',
              width: '50%'
            },
            {
              text: 'BULK CONTACT NAME:' + this.pdfDataObject.bulkContactName + ' \n' + 'BULK CONTACT PHONE NUMBER:' + this.pdfDataObject.bulkContactNumber,
              alignment: 'left',
              width: '50%',
              marginLeft: 30,
            },
            ]
          }
        ];
        tblObject.push(tblbulkItemHeader);
      }
      else {
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['25%', '25%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Order ID: ' + this.pdfDataObject.webOrderNumber.toString() + '-' + obj.splitId.toString(),
              alignment: 'left',
            },
            {
              text: 'Status: ' + obj.orderStatus.toString(),
              alignment: 'left',
            }
              //  ,
              // {
              //  text: 'Requested Delivery Date: ' + desiredDeliveryDate,
              //  alignment: 'right',
              //  }
            ]
          }
        ];

        tblObject.push(tblHeader);
      }

      if (this.isBulkItemAvailable) {
        const tblwithBulk = {
          table: {
            widths: ['30%', '15%', '15%', '25%', '15%'], // , '10%', '10%', '10%', '15%'
            color: '#0b3f54',
            body: [
              [{
                text: 'Product',
                style: 'tableHeader'
              },
              {
                text: 'Ordered Quantity',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Ordering UOM',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Package Size',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'BULK REQUESTED DATE',
                style: 'tableHeader', alignment: 'center'
              },

              ],
              ...blanketOrderDetails.map(bo => {
                var cellData = [],
                  cellData = this.cppModifiedCellData(bo);
                return [
                  {
                    text: cellData
                  },
                  { text: bo.lineStatus == 'CANCELLED' ? 'Cancelled' : bo.originalOrderQuantity.toFixed(this.commonService.countDecimals(bo.originalOrderQuantity)), alignment: 'center' },
                  { text: bo.uom, alignment: 'center' },
                  { text: bo.packageSize, alignment: 'center' },
                  { text: bo.bulkPackaged.toLowerCase() != 'bulk' ? ' ' : new Date(bo.desiredDeliveryDate).toLocaleDateString('en-US'), alignment: 'center' },
                ];
              })
            ]
          },
          style: 'tablefont',
        };
        tbl = tblwithBulk;
      }
      else {
        const tblwithoutbulk = {
          table: {
            widths: ['45%', '15%', '15%', '25%'], // , '10%', '10%', '10%', '15%'
            color: '#0b3f54',
            body: [
              [{
                text: 'Product',
                style: 'tableHeader'
              },
              {
                text: 'Ordered Quantity',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Ordering UOM',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Package Size',
                style: 'tableHeader', alignment: 'center'
              },
                // {
                //  text: 'Priced Quantity',
                //  style: 'tableHeader', alignment: 'center'
                // },
                // {
                //  text: 'Price UOM',
                //  style: 'tableHeader', alignment: 'center'
                // },
                // {
                //  text: 'Unit Price (USD)',
                //  style: 'tableHeader', alignment: 'center'
                // },

                // {
                //  text: 'Item Total',
                //  style: 'tableHeader', alignment: 'right'
                // },
              ],
              ...blanketOrderDetails.map(bo => {
                var cellData = [],
                  cellData = this.cppModifiedCellData(bo);
                return [
                  {
                    text: cellData
                  },
                  /* ((bo.itemVendorName) ? (bo.itemVendorName + " \n" + bo.itemDescription) : '' + bo.itemDescription),*/
                  { text: bo.lineStatus == 'CANCELLED' ? 'Cancelled' : bo.originalOrderQuantity.toFixed(this.commonService.countDecimals(bo.originalOrderQuantity)), alignment: 'center' },
                  { text: bo.uom, alignment: 'center' },
                  { text: bo.packageSize, alignment: 'center' },
                  // { text: bo.pricePerOrderUnit.toFixed(4), alignment: 'center' },
                  // { text: bo.pricingUnitOfMeasure, alignment: 'center' },
                  // { text: bo.pricePerUnit.toFixed(4), alignment: 'center' },
                  // { text: bo.totalPrice.toFixed(2), alignment: 'right' },
                ];
              })
            ]
          },
          style: 'tablefont',
        };

        tbl = tblwithoutbulk;
      }
      tblObject.push(tbl);
    });

    return tblObject;
  }

  // Email order detail
  emailBlanketOrder(obj: any) {
    this.tabNode = this.tabNode ? false : true;
    const data = this.isSubscriptionAccess ? { title: 'Send Email', tabNode: this.tabNode, dialogType: 'nonSubscriberEmail' } : { email: obj.emailId, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' };
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: data
    });

    this.subscription.push(emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          WebOrderNumber: obj.blanketOrderNumber,
          EmailIds: emailIds
        };

        this.subscription.push(this.blanketOrderService.sendBlanketOrderConfirmationEmail(data).subscribe(result => {
          if (result) { this.toastrService.success('Email sent'); }
        }));
      }
      this.tabNode = false;
    }));
  }
  // For your price and payment Term in the cell with style
  cppModifiedCellData(cpp) {
    const tempArray = [];
    if (cpp.itemVendorName) {
      tempArray.push(cpp.itemVendorName + ' \n' + cpp.itemDescription + '\n');
    }
    else {
      tempArray.push('' + cpp.itemDescription + '\n');
    }
    if (this.plAccess && cpp.yourPrice != null && cpp.yourPrice != '' && cpp.yourPrice != undefined && cpp.yourPrice != 0) {
      tempArray.push({
        text: ('$' + cpp.yourPrice.toFixed(4) + '/' + cpp.pricingUOM + '\n'), style: 'tableUnit'
      });
    }
    if (this.plAccess && cpp.paymentTerms != null && cpp.paymentTerms != '' && cpp.paymentTerms != undefined) {
      tempArray.push({
        text: (cpp.paymentTerms.trim()), style: 'tablePayment'
      });
    }

    return tempArray;
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
